import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CourseCatalogOverview } from 'app/library/course-catalog/models/course-catalog-overview.model';

@Injectable()
export class CourseCatalogService {
    private _overview$ = new BehaviorSubject<CourseCatalogOverview | null>(null);
    overview$ = this._overview$.asObservable();

    private _selectedCategoryId$ = new BehaviorSubject<string | null>(null);
    selectedCategoryId$ = this._selectedCategoryId$.asObservable();

    setOverview(overview: CourseCatalogOverview) {
        this._overview$.next(overview);
    }

    getOverview(): CourseCatalogOverview | null {
        return this._overview$.getValue();
    }

    setSelectedCategoryId(id: string) {
        this._selectedCategoryId$.next(id);
    }
}
